import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import _ from 'lodash';

import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';

import { selectPreference, changePreference, deletePreference, updatePreference, updatePreferenceMeta } from 'actions/preferences/index';
import { createFilterAnnotations } from 'actions/preferences/filterAnnotations';

import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

import LevelList from './LevelList'
import Settings from './Settings';

const styles = {
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
};

function immutablySwapItems(items, firstIndex, secondIndex) {
    const results= items.slice();
    const firstItem = items[firstIndex];

    results[firstIndex] = items[secondIndex];
    results[secondIndex] = firstItem;

    return results;
}

function guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}

class FiltersAnnotations extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            levelList: [],
            disabledActions: false,
        };

        this.addLevel = this.addLevel.bind(this);
        this.removeLevel = this.removeLevel.bind(this);
        this.changeLevelList = this.changeLevelList.bind(this);

        this.moveLevel = this.moveLevel.bind(this);

        this.sendNewPreference = this.sendNewPreference.bind(this);
        this.selectPreference = this.selectPreference.bind(this);
        this.deletePreference = this.deletePreference.bind(this);
        this.updatePreference = this.updatePreference.bind(this);
        this.toggleShared = this.toggleShared.bind(this);
    }

    toggleShared(e, value) {
        this.props.changePreference({
            shared: value,
            levelList: this.state.levelList,
        });
    }

    moveLevel(dragIndex, hoverIndex) {
        let levelList = _.cloneDeep(this.state.levelList);

        levelList = immutablySwapItems(levelList, dragIndex, hoverIndex).map((item, key) => {
            return {
                ...item,
                priority: key,
            }
        });

        this.changeLevelList(levelList);
    }

    addLevel() {
        const { levelList } = this.state;

        levelList.push({
            id: guid(),
            priority: levelList.length,
            levelType: 'single',
            rulesList: [],
        });

        this.changeLevelList(levelList);
    }

    removeLevel() {
        const { levelList } = this.state;
        levelList.splice(levelList.length - 1, 1);
        this.changeLevelList(levelList);
    }

    deletePreference() {
        this.props.deletePreference({
            _id: this.props.selected._id,
        });
    }

    updatePreference() {
        this.props.updatePreference(this.props.selected.filter, this.props.selected._id);
        this.props.updatePreferenceMeta(this.props.selected);
    }

    changeLevelList(levelList) {
        this.props.changePreference({ levelList });
    }

    sendNewPreference(name) {
        this.props.createFilterAnnotations({
            name,
            targetType: this.props.selectedType,
            levelList: this.state.levelList,
        })
    }

    selectPreference(_id) {
        this.props.selectPreference({
            _id,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let disabledActions = false;

        if (nextProps.selected.userId !== this.props.userId) {
            disabledActions = true;
        }

        this.setState({
            levelList: nextProps.selected._id ? nextProps.selected.filter.levelList : [],
            disabledActions,
        });
    }

    render() {
        const { levelList, disabledActions } = this.state;
        const { renderWithAnnotationFilters, renderOriginalAnnotations, selectedType, selected } = this.props;

        return (
            <div className='sidebar-table'>
                <Settings
                    selectedType={selectedType}
                    sendNewPreference={this.sendNewPreference}
                    selectPreference={this.selectPreference}
                    updatePreference={this.updatePreference}
                    deletePreference={this.deletePreference}
                    toggleShared={this.toggleShared}
                />

                {
                    selected._id
                        ?
                        <Fragment>
                            <div className="paper-block margin-10">
                                <span className='name-block absolute small-name'>Management</span>
                                <div className="row">
                                    <div className="col-xs-3">
                                        <RaisedButton
                                            label='render'
                                            labelStyle={styles.button.labelStyle}
                                            style={styles.button.style}
                                            buttonStyle={styles.button.buttonStyle}
                                            primary
                                            onClick={() => {
                                                renderWithAnnotationFilters(levelList);
                                            }}
                                        />
                                    </div>

                                    <div className="col-xs-3">
                                        <RaisedButton
                                            label='clear'
                                            labelStyle={styles.button.labelStyle}
                                            style={styles.button.style}
                                            buttonStyle={styles.button.buttonStyle}
                                            primary
                                            onClick={() => {
                                                renderOriginalAnnotations(levelList);
                                            }}
                                        />
                                    </div>

                                    {
                                        !disabledActions
                                            ?
                                            <div className="col-xs-3 middle-xs" style={{ display: 'flex' }}>
                                                <div style={{ fontSize: '12px' }}>Levels</div>

                                                <IconButton>
                                                    <ContentAddIcon
                                                        onClick={this.addLevel}
                                                        color='green'
                                                    />
                                                </IconButton>

                                                <IconButton>
                                                    <ContentRemoveIcon
                                                        onClick={this.removeLevel}
                                                        color='red'
                                                    />
                                                </IconButton>
                                            </div>
                                            :
                                            ''
                                    }

                                </div>
                            </div>

                            <LevelList
                                changeLevelList={this.changeLevelList}
                                levelList={levelList}
                                moveLevel={this.moveLevel}
                                disabledActions={disabledActions}
                            />
                        </Fragment>
                        :
                        ''
                }


            </div>
        );
    }
}

FiltersAnnotations.propTypes = {
    renderWithAnnotationFilters: PropTypes.func,
    renderOriginalAnnotations: PropTypes.func,
    user: PropTypes.string,
    selectedType: PropTypes.string,
    createFilterAnnotations: PropTypes.func,
    selectPreference: PropTypes.func,
    changePreference: PropTypes.func,
    deletePreference: PropTypes.func,
    updatePreference: PropTypes.func,
    updatePreferenceMeta: PropTypes.func,
};

const ConnectFiltersAnnotations = connect(
    ({ preferences: { selected }, user: { user } },
     { toggleShared, renderWithAnnotationFilters, renderOriginalAnnotations, selectedType }) => {
        return {
            userId: user._id,
            renderWithAnnotationFilters,
            renderOriginalAnnotations,
            selectedType,
            selected,
            toggleShared,
        };
    },
    dispatch => bindActionCreators({
        createFilterAnnotations,
        selectPreference,
        changePreference,
        deletePreference,
        updatePreference,
        updatePreferenceMeta,
    }, dispatch),
)(FiltersAnnotations);

export default DragDropContext(HTML5Backend)(ConnectFiltersAnnotations);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Sidebar/FiltersAnnotations.jsx